import { useLocation } from 'react-router-dom'
import { useAuth } from '@/auth/useAuth'
import { useTranslation } from '@/i18n/useTranslation'
import { ROUTES, isRouteActive } from '@/lib/routes'

export interface NavItemData {
  href:  string
  label: string
}

export interface UseSidebarReturn {
  navItems:     NavItemData[]
  isActive:     (href: string) => boolean
  handleLogout: () => void
  logoutLabel:  string
}

export function useSidebar(): UseSidebarReturn {
  const { pathname } = useLocation()
  const { signOut } = useAuth()
  const { t } = useTranslation('layout')

  const navItems: NavItemData[] = ROUTES
    .filter(r => r.inSidebar)
    .map(r => ({ href: r.path, label: t(`layout.nav.${r.navKey}`) }))

  function isActive(href: string) {
    return isRouteActive(pathname, href)
  }

  function handleLogout() {
    signOut()
  }

  return { navItems, isActive, handleLogout, logoutLabel: t('layout.nav.logout') }
}
